import * as React from "react";

const Undo: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17">
            <g fill="none" fillRule="evenodd">
                <g fill="#006AE3" fillRule="nonzero">
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M9.711 4.062h-5.81l2.285-2.22L4.569.272.333 4.388c-.216.208-.336.49-.336.784 0 .295.12.577.336.785l4.236 4.116 1.617-1.57L3.9 6.282h5.811c2.209 0 4 1.739 4 3.884 0 2.145-1.791 3.885-4 3.885H4.57v2.22H9.71c2.246 0 4.32-1.163 5.443-3.053 1.124-1.889 1.124-4.215 0-6.104-1.123-1.89-3.197-3.053-5.443-3.053z"
                                    transform="translate(-965 -534) translate(80 531) translate(885 1) translate(0 2)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Undo);
